/**
 * ChannelChoiceTitle component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled channel choice title.
 */
const ChannelChoiceTitle = styled.p`
  color: white;
  font-size: ${42 * Screen.widthRatio}px;
  text-align: center;
  font-family: ${Fonts['regular']};
  line-height: ${48 * Screen.widthRatio}px;
  margin-top: 0;
  margin-bottom: ${24 * Screen.widthRatio}px;
`;

export default ChannelChoiceTitle;
